/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CreateBackupReport {
    getFixupPrototypeFunction() { return CreateBackupReport.fixupPrototype; }

    static newInstance(model: Partial<CreateBackupReport>): CreateBackupReport {
        let obj = Object.assign(new CreateBackupReport(), model);
        CreateBackupReport.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CreateBackupReport>): CreateBackupReport {
        if (!model) return null;
        return CreateBackupReport.newInstance(<CreateBackupReport> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CreateBackupReport) {
        if (!obj) return;

        models.CreateBackupReport.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CreateBackupReport): boolean {
        Object.setPrototypeOf(obj, CreateBackupReport.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * span name
     */
    span: models.BackupReportSpan;

    /**
     * Specify the Cloud Account ID. This can be fetched from List CloudAccounts API call.
     */
    cloud_account_id: string;

    /**
     * Specify the tenant ID. This is a unique ID and can be retrieved using the List Tenants API.
     */
    tenant_id: string;

}
